import { render } from "./CollectionImages.vue?vue&type=template&id=53b5a4ab&scoped=true"
import script from "./CollectionImages.vue?vue&type=script&lang=js"
export * from "./CollectionImages.vue?vue&type=script&lang=js"

import "./CollectionImages.vue?vue&type=style&index=0&id=53b5a4ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b5a4ab"]])

export default __exports__